import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalPermissionsConditionsService {
  public testCondition$ = of(true);
}
